import { render, staticRenderFns } from "./columnRatingCompaniesToolTip.vue?vue&type=template&id=50784a4d&scoped=true"
import script from "./columnRatingCompaniesToolTip.vue?vue&type=script&lang=ts"
export * from "./columnRatingCompaniesToolTip.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50784a4d",
  null
  
)

export default component.exports